import { render, staticRenderFns } from "./PortraitLabels.vue?vue&type=template&id=37a068a7&"
import script from "./PortraitLabels.vue?vue&type=script&lang=js&"
export * from "./PortraitLabels.vue?vue&type=script&lang=js&"
import style0 from "./PortraitLabels.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a068a7')) {
      api.createRecord('37a068a7', component.options)
    } else {
      api.reload('37a068a7', component.options)
    }
    module.hot.accept("./PortraitLabels.vue?vue&type=template&id=37a068a7&", function () {
      api.rerender('37a068a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/PortraitLabels.vue"
export default component.exports